import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   

    getArticleIndex(state,value){
        
        
       
        post(urls.admin.article.index,value).then((result)=>{
          
          
          
          state.result=result


        
       
        
       
           
        });
        
    },
   

    addArticle(state,value){
        
        

        post(urls.admin.article.add,value).then((result)=>{
          

          
          state.result=result
        
       
        
       
           
        });
        
    },
    editArticle(state,value){



        post(urls.admin.article.edit,value).then((result)=>{



            state.result=result





        });

    },
    deleteArticle(state,value){



        post(urls.admin.article.delete,value).then((result)=>{



            state.result=result





        });

    },


    
   

    

}
const  actions={


    getArticleIndexAction(context,value){
       
        context.commit("getArticleIndex",value)
       
    },
  
    addArticleAction(context,value){
       
        context.commit("addArticle",value)
       
    },
    editArticleAction(context,value){

        context.commit("editArticle",value)

    },
    deleteArticleAction(context,value){

        context.commit("deleteArticle",value)

    },



    
    

}

export default {state,mutations,actions}